import { bus } from '../../utils'

export default {
  beforeDestroy () {
    bus.$off('show-delete-user')
  },
  computed: {
    email () {
      return this.info.email
    }
  },
  methods: {
    closePopup () {
      this.showModal = false
    },
    async deleteUser (id) {
      return await this.$api.removeUser(id)
          .then(() => bus.$emit('update-deleted-user-list', id))
          .catch((error) => new Error(`Failed to delete user, please try again later (Error: ${JSON.stringify(error)})`))
    }
  },
  name: 'UserDelete',
  data () {
    return {
      buttons: [
        {
          id: 'Close',
          class: 'btn-close',
          text: 'userDeleteDialogButtonCloseText',
          type: 'text',
          click: () => { this.closePopup() }
        },
        {
          id: 'Delete',
          text: 'userDeleteDialogButtonDeleteText',
          type: 'warning',
          click: () => {
            this.deleteUser(this.info.id)
            this.closePopup()
          }
        }
      ],
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      info: {},
      showModal: false
    }
  },
  mounted () {
    bus.$on('show-delete-user', ({ show, info }) => {
      if (show) {
        this.showModal = true
      }

      if (info) {
        this.info = info
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/UserDelete/UserDelete.js